// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { StatusAreaId } from './StatusAreaId'
import {
  StatusAreaNavigation,
  StatusAreaNavigationIcon,
} from './StatusAreaNavigation'
import { StatusAreaRoutes } from './StatusAreaRoutes'

const LazyStatusComponent = lazy(() => import('./StatusArea'))

const StatusComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyStatusComponent />
  </SuspenseLoadingWrapper>
)

export const StatusArea = {
  id: StatusAreaId,
  Icon: StatusAreaNavigationIcon,
  NavigationComponent: StatusAreaNavigation,
  route: {
    path: StatusAreaRoutes.route,
    component: StatusComponent,
  },
}
